import type { Route } from 'next'

/** typedRoutes 가 알 수 없는 동적 경로(작품 id·쿼리)를 Route 로 표시한다 */
export const to = (path: string) => path as Route
